// extracted by mini-css-extract-plugin
export default {"saveFilterWrap":"SaveFilterBlock_saveFilterWrap__AV4GL","save":"SaveFilterBlock_save__795qt","changeFilterButtons":"SaveFilterBlock_changeFilterButtons__OgaiZ"};